import { render, staticRenderFns } from "./GuidelineRanges.vue?vue&type=template&id=64e37d58&scoped=true"
import script from "./GuidelineRanges.vue?vue&type=script&lang=ts"
export * from "./GuidelineRanges.vue?vue&type=script&lang=ts"
import style0 from "./GuidelineRanges.vue?vue&type=style&index=0&id=64e37d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e37d58",
  null
  
)

export default component.exports